import React, {Component} from 'react';
import {
  StyleSheet,
  View,
  Text,
  ScrollView,
  TouchableOpacity,
  SafeAreaView,
  Dimensions,
  Image,
} from 'react-native';
import colors from '../../HelperClasses/AppColor';
import networkService from '../../Network/NetworkManager';
import Appload from '../../HelperClasses/AppLoaderClasses/AppLoader';
import PropTypes from 'prop-types';
import {AppToast} from '../../HelperClasses/AppToast';
import commonStyle from '../../StyleSheets/CommonStyleSheet';
import {onHandleNumberFieldChange} from '../../HelperClasses/SingletonClass';
import Switch from 'react-switch';
import AppColor from '../../HelperClasses/AppColor';
import {addMixpanelEvent, MixPannelEnum} from '../../Models/MixPannelEnum';
import SaveButton from '../../Component/SaveButton';
import AppConstants from '../../Constants/AppConstants';
import AppConstantsMessage from '../../Constants/AppConstantsMessage';
import {ThemeContext} from '../../HelperClasses/ThemeContext';
import FormTextInput from '../../UI/Form/TextInput';
import FormTextArea from '../../UI/Form/TextArea';
import {PaymentMethodEnum} from '../../Models/CommonEnum';
import StripeIntegration from './StripeIntegration';
import PayU from './PayU';
import BillPlzIntegration from './BillPlzIntegration';
import OPPSetup from './OPPSetup';
import RazorpaySettings from './RazorpaySettings';
import PayDunyaSettings from './PayDunyaSettings';
import PawaPayIntegration from './PawaPayIntegration';
import KoraPayIntegration from './KoraPayIntegration';
import PayStackIntegration from './PayStackIntegration';
import FlutterwaveIntegration from './FlutterwaveIntegration';
import CommercePayIntegration from './CommercePayIntegration';
import CheckoutDotComIntegration from './CheckoutDotCOmIntegration';
import {withLocale} from '../../Localization/LocaleContext';
import {paymentMethodDraftKey, readPaymentMethodDraft, writePaymentMethodDraft, clearPaymentMethodDraft} from './paymentMethodDrafts';

const APPURL = require('../../Constants/URLConstants');

const windowWidth = Dimensions.get('window').width;
const windowHeight = Dimensions.get('window').height;
let fixedWidth = AppConstants.mobileMaxWidth;
let itsMobileView = windowWidth < fixedWidth ? true : false;

class AddPaymentMenthod extends Component {
  static contextType = ThemeContext;
  integrationRef = React.createRef();
  constructor(props) {
    super(props);
    this.draftKey = paymentMethodDraftKey(props.isEdit ? props.paymentMethodData?.id : 'new');
    this.savedDraft = props.isIntegration ? {} : readPaymentMethodDraft(this.draftKey);
    this.state = {
      step: 1,
      status: true,
      default: true,
      name: '',
      note: '',
      dataLoad: false,
      id: '',
      paymentMethodsArray: [],
      updatingBool: false,
      rank: '',
      regexp: /^[0-9\.]+$/,
      maximumAmount: '',
      minimumAmount: '',
      selectedPaymentMethod: '',
      selectedPaymentMethodID: '',
      selectedPaymentMethodType: '',
      type: '',
      showUpgrade: false,
      ...this.savedDraft,
    };
  }
  static propTypes = {
    backBtnAction: PropTypes.func,
    paymentMethodData: PropTypes.any,
    isEdit: PropTypes.bool,
    isIntegration: PropTypes.bool,
    type: PropTypes.string,
  };
  t = (key, fallback) => this.props.localeContext?.translate?.(key, fallback) || fallback || key;
  componentDidUpdate() {
    if (this.draftReady && !this.props.isIntegration) writePaymentMethodDraft(this.draftKey, this.state);
  }
  componentDidMount() {
    const catData = this.props.paymentMethodData;
    const isEdit = this.props.isEdit;
    const isIntegration = this.props.isIntegration;
    if (isIntegration && catData) {
      this.setState({
        step: 3,
        dataLoad: true,
        selectedPaymentMethodType: catData['type'] || '',
        selectedPaymentMethod: catData['name'] || '',
        selectedPaymentMethodID: catData['payment_method_id'] || catData['id'] || '',
      });
      return;
    }
    if (isEdit) {
      if (!this.state.updatingBool) {
        this.setState({
          step: 2,
          name: catData['name'],
          note: catData['note'],
          status: catData['active'],
          default: catData['default'],
          id: catData['id'],
          maximumAmount: catData['max_amount'],
          minimumAmount: catData['min_amount'],
          rank: catData['order_by'],
          type: catData['type'],
          updatingBool: true,
        });
      }
    }
    this.loadPaymentMethodsApi();
  }
  //MARK:- Api Methods
  loadPaymentMethodsApi = async () => {
    const responseJson = await networkService.networkCall(
      APPURL.URLPaths.paymentMethod,
      'get',
      '',
      '',
    );
    this.setState({paymentMethodsArray: []});
    if (responseJson['status'] == true) {
      var objectD = responseJson['data']['payment_methods'];
      for (let obj of objectD) {
        this.state.paymentMethodsArray.push(obj);
      }
      if (this.state.paymentMethodsArray.length != 0) {
        if (this.state.id !== '') {
          let index = this.state.paymentMethodsArray.findIndex(
            x => x.type == this.state.type,
          );
          if (index != -1 && Object.keys(this.savedDraft).length === 0) {
            let item = this.state.paymentMethodsArray[index];
            this.setState({
              selectedPaymentMethod: item['name'],
              selectedPaymentMethodID: item['id'],
              selectedPaymentMethodType: item['type'],
            });
          }
        } else {
          // don't auto-select in new mode — user picks from card grid
        }
      }
    }
    if (Object.keys(this.savedDraft).length) this.setState({...this.savedDraft});
    this.draftReady = true;
    this.setState({dataLoad: true});
  };
  addPaymentMethodApi = async () => {
    var dict = {
      payment_method_id: this.state.selectedPaymentMethodID,
      name: this.state.name,
      active: this.state.status,
      default: this.state.default,
    };
    if (this.state.note) {
      dict.note = this.state.note;
    }
    if (this.state.minimumAmount && this.state.minimumAmount !== '') {
      Object.assign(dict, {min_amount: this.state.minimumAmount});
    }
    if (this.state.maximumAmount && this.state.maximumAmount !== '') {
      Object.assign(dict, {max_amount: this.state.maximumAmount});
    }
    if (this.state.rank != 0) {
      dict['order_by'] = this.state.rank;
    }
    var path = APPURL.URLPaths.tenantPaymentMethod;
    if (this.state.id !== '') {
      path = APPURL.URLPaths.tenantPaymentMethod + '/' + this.state.id;
    }
    const responseJson = await networkService.networkCall(
      path,
      this.state.id !== '' ? 'put' : 'post',
      JSON.stringify({payment_method: dict}),
    );
    if (responseJson['status'] == true && !this.props.isIntegration) {
      this.draftReady = false;
      clearPaymentMethodDraft(this.draftKey);
    }
    this.setState({dataLoad: true});
    if (responseJson['status'] == true) {
      this.mixpanelInfo(true);
      window?.FM?.trackCustomEvent('Payment', {
        email: AppConstants.userEmail,
        payment_method: dict,
      });
      this.customAlert();
      const hasIntegration = this.getIntegrationComponent() !== null;
      if (hasIntegration && !this.props.isEdit) {
        this.setState({step: 3});
      } else {
        this.props.backBtnAction(true);
      }
    } else {
      this.mixpanelInfo(false);
      AppToast(responseJson);
    }
  };
  mixpanelInfo(resp) {
    let properties = {success: resp};
    let event =
      this.state.id !== ''
        ? MixPannelEnum.editPaymentMethod
        : MixPannelEnum.addPaymentMethod;
    addMixpanelEvent(event, properties);
  }
  customAlert() {
    AppToast();
  }
  checkRestriction() {
    let check_access = AppConstants.accessControl?.[
      AppConstants.plan_name
    ]?.includes(this.state.selectedPaymentMethodType);
    return check_access;
  }
  //MARK:- Button Actions
  submitBtnAction = () => {
    this.setState({dataLoad: false});
    this.addPaymentMethodApi();
  };
  didSelectDropDown = item => {
    this.setState({
      selectedPaymentMethod: item['name'],
      selectedPaymentMethodID: item['id'],
      selectedPaymentMethodType: item['type'],
    });
  };
  onHandleTextChange = (id, text) => {
    let value = text;
    if (text == '' || this.state.regexp.test(value)) {
      if (id == 1) {
        this.setState({maximumAmount: text});
      } else {
        this.setState({minimumAmount: text});
      }
    }
  };
  // UI Renders
  getIntegrationComponent = () => {
    const type = this.state.selectedPaymentMethodType;
    const ref = this.integrationRef;
    const p = {embedded: true, ref};
    switch (type) {
      case PaymentMethodEnum.stripe:      return <StripeIntegration {...p} type={PaymentMethodEnum.stripe} />;
      case PaymentMethodEnum.stripe_web:  return <StripeIntegration {...p} type={PaymentMethodEnum.stripe_web} />;
      case PaymentMethodEnum.payulatam:   return <PayU {...p} />;
      case PaymentMethodEnum.billplz:     return <BillPlzIntegration {...p} />;
      case PaymentMethodEnum.opp:         return <OPPSetup {...p} />;
      case PaymentMethodEnum.razorpay:    return <RazorpaySettings {...p} />;
      case PaymentMethodEnum.paydunya:    return <PayDunyaSettings {...p} />;
      case PaymentMethodEnum.pawapay:     return <PawaPayIntegration {...p} />;
      case PaymentMethodEnum.korapay:     return <KoraPayIntegration {...p} />;
      case PaymentMethodEnum.paystack:    return <PayStackIntegration {...p} />;
      case PaymentMethodEnum.flutterwave: return <FlutterwaveIntegration {...p} />;
      case PaymentMethodEnum.commercepay: return <CommercePayIntegration {...p} />;
      case PaymentMethodEnum.checkout_dot_com: return <CheckoutDotComIntegration {...p} />;
      default: return null;
    }
  };

  getPaymentIcon = type => {
    const map = {
      stripe: '💳', stripe_native: '💳', stripe_connect: '💳',
      cash_on_delivery: '💵', cash: '💵', cod: '💵',
      upi: '📱', upi_on_delivery: '📱', upi_collect: '📱',
      paypal: '🅿️',
      razorpay: '🏦', payu: '🏦', paytm: '🏦',
      bank_transfer: '🏛️', bank: '🏛️',
      wallet: '👛',
    };
    if (!type) return '💰';
    const lower = String(type).toLowerCase();
    for (const key of Object.keys(map)) {
      if (lower.includes(key)) return map[key];
    }
    return '💰';
  };

  getPaymentLogo = type => {
    const logos = {
      stripe: 'stripe',
      stripe_web: 'stripe',
      payulatam: 'payu',
      billplz: 'billplz',
      razorpay: 'razorpay',
      paydunya: 'paydunya',
      mangopay: 'mangopay',
      pawapay: 'pawapay',
      korapay: 'korapay',
      paystack: 'paystack',
      flutterwave: 'flutterwave',
      checkoutcom: 'checkoutdotcom',
    };
    const slug = logos[String(type || '').toLowerCase()];
    return slug ? `https://cdn.simpleicons.org/${slug}` : null;
  };

  renderPaymentMark = (type, size = 28) => {
    const logo = this.getPaymentLogo(type);
    return logo ? (
      <Image
        source={{uri: logo}}
        style={{width: size, height: size, marginBottom: size === 24 ? 0 : 8}}
        resizeMode="contain"
        accessibilityLabel={this.t('payments.accessibility.gateway_logo', 'Payment gateway logo')}
      />
    ) : (
      <Text style={{fontSize: size - 2, marginBottom: size === 24 ? 0 : 8}}>
        {this.getPaymentIcon(type)}
      </Text>
    );
  };

  titleLblRender = ({title}) => (
    <View>
      <Text style={commonStyle.titleNameStyle}>
        {title}
        <Text style={{color: 'red', paddingTop: 5}}> *</Text>
      </Text>
    </View>
  );

  renderStepper = () => {
    const {step, selectedPaymentMethodID} = this.state;
    const isEdit = this.props.isEdit;
    const canNext = selectedPaymentMethodID !== '';

    const circle = (n, active) => (
      <View style={{alignItems: 'center', justifyContent: 'center',
        width: 28, height: 28, borderRadius: 14,
        backgroundColor: active ? colors.AppNewGreen : 'var(--color-border)'}}>
        <Text style={{fontSize: 13, fontWeight: '600',
          color: active ? '#fff' : 'var(--color-text-secondary)'}}>
          {n}
        </Text>
      </View>
    );

    const labels = [this.t('payments.step_select_type', 'Select Type'), this.t('payments.step_configure', 'Configure'), this.t('payments.step_integration', 'Integration')];
    const totalSteps = [1, 2, 3];
    return (
      <View style={{flexDirection: 'row', alignItems: 'center',
        paddingVertical: 12, paddingHorizontal: 16,
        borderBottomWidth: 1, borderBottomColor: 'var(--color-border)'}}>
        {/* stepper */}
        <View style={{flex: 1, flexDirection: 'row', alignItems: 'center'}}>
          {totalSteps.map((n, i) => (
            <React.Fragment key={n}>
              <TouchableOpacity
                onPress={() => !isEdit && n < step && this.setState({step: n})}
                style={{alignItems: 'center'}}
                activeOpacity={!isEdit && n < step ? 0.6 : 1}>
                {circle(n, step >= n)}
                <Text style={{fontSize: 9, marginTop: 4,
                  color: step >= n ? colors.AppNewGreen : 'var(--color-text-secondary)',
                  fontWeight: step >= n ? '600' : '400',
                  textDecorationLine: !isEdit && n < step ? 'underline' : 'none'}}>
                  {labels[i]}
                </Text>
              </TouchableOpacity>
              {i < 2 && (
                <View style={{flex: 1, height: 2, marginHorizontal: 6, marginBottom: 14,
                  backgroundColor: step > n ? colors.AppNewGreen : 'var(--color-border)'}} />
              )}
            </React.Fragment>
          ))}
        </View>

        {/* Action button */}
        <View style={{marginLeft: 12}}>
          {step === 1 && (
            <SaveButton
              saveBtn={() => canNext && this.setState({step: 2})}
              saveBtnTitle={this.t('payments.next', 'Next →')}
              showSaveBtn={canNext}
            />
          )}
          {step === 2 && (
            <SaveButton
              saveBtn={() => this.submitBtnAction()}
              saveBtnTitle={this.t('payments.save', 'Save')}
              btnDeActive={this.checkRestriction()}
              deActiveBtnAction={() => this.setState({showUpgrade: true})}
              showLock={true}
            />
          )}
          {step === 3 && (
            <SaveButton
              saveBtn={() => this.integrationRef.current?.submitBtnAction?.()}
              saveBtnTitle={this.t('payments.save', 'Save')}
            />
          )}
        </View>
      </View>
    );
  };

  renderCardRow = (items, selectedPaymentMethodID) => {
    return (
      <View style={{flexDirection: 'row', marginBottom: 10}}>
        {items.map((item, idx) => {
          const selected = item.id === selectedPaymentMethodID;
          return (
            <TouchableOpacity
              key={item.id}
              onPress={() => this.didSelectDropDown(item)}
              style={{
                flex: 1,
                marginLeft: idx > 0 ? 10 : 0,
                padding: 14, borderRadius: 10,
                borderWidth: selected ? 2 : 1,
                borderColor: selected ? colors.AppNewGreen : 'var(--color-border)',
                backgroundColor: selected ? 'rgba(1,84,78,0.08)' : 'var(--color-surface)',
                alignItems: 'center',
              }}>
              {this.renderPaymentMark(item.type)}
              <Text style={{fontSize: 12, fontWeight: '500', textAlign: 'center',
                color: selected ? colors.AppNewGreen : 'var(--color-text)', lineHeight: 17}}>
                {item.name}
              </Text>
            </TouchableOpacity>
          );
        })}
      </View>
    );
  };

  renderStep1 = () => {
    const {paymentMethodsArray, selectedPaymentMethodID} = this.state;
    const canNext = selectedPaymentMethodID !== '';
    const stripeTypes = [PaymentMethodEnum.stripe, PaymentMethodEnum.stripe_web];
    const sorted = [
      ...paymentMethodsArray.filter(m => stripeTypes.includes(m.type)),
      ...paymentMethodsArray.filter(m => !stripeTypes.includes(m.type)),
    ];
    // chunk into rows of 2
    const rows = [];
    for (let i = 0; i < sorted.length; i += 2) {
      rows.push(sorted.slice(i, i + 2));
    }
    return (
      <View style={{padding: 16}}>
        <Text style={{fontSize: 13, color: 'var(--color-text-secondary)', marginBottom: 14}}>
          {this.t('payments.choose_method', 'Choose a payment method to configure')}
        </Text>
        {rows.map((row, i) => (
          <View key={i}>{this.renderCardRow(row, selectedPaymentMethodID)}</View>
        ))}
      </View>
    );
  };

  renderStep2 = () => {
    const field = {marginBottom: 14};
    return (
      <View style={{padding: 16}}>
        {this.state.selectedPaymentMethod ? (
          <View style={{flexDirection: 'row', alignItems: 'center',
            padding: 10, borderRadius: 8, marginBottom: 14,
            backgroundColor: 'var(--color-surface)',
            borderWidth: 1, borderColor: 'var(--color-border)'}}>
            <View style={{marginRight: 8}}>
              {this.renderPaymentMark(this.state.selectedPaymentMethodType, 24)}
            </View>
            <Text style={{fontSize: 14, fontWeight: '600', color: 'var(--color-text)'}}>
              {this.state.selectedPaymentMethod}
            </Text>
          </View>
        ) : null}

        <View style={field}>
          <FormTextInput
            title={this.t('payments.name', 'Name')}
            isRequired={true}
            placeholder={this.t('payments.enter_name', 'Enter name')}
            current_data={this.state.name}
            update_data={name => this.setState({name})}
          />
        </View>
        <View style={field}>
          <FormTextInput
            title={this.t('payments.maximum_amount', 'Maximum amount')}
            placeholder={this.t('payments.enter_maximum_amount', 'Enter maximum amount')}
            type="number"
            current_data={this.state.maximumAmount}
            update_data={text => this.onHandleTextChange(1, text)}
          />
        </View>
        <View style={field}>
          <FormTextInput
            title={this.t('payments.minimum_amount', 'Minimum amount')}
            placeholder={this.t('payments.enter_minimum_amount', 'Enter minimum amount')}
            type="number"
            current_data={this.state.minimumAmount}
            update_data={text => this.onHandleTextChange(2, text)}
          />
        </View>
        <View style={field}>
          <FormTextArea
            title={this.t('payments.note', 'Note')}
            placeholder={this.t('payments.enter_note', 'Enter note')}
            tooltip={this.t('payments.note_tooltip', AppConstantsMessage.notePaymentSubTitleToolTipMsg)}
            current_data={this.state.note}
            update_data={note => this.setState({note})}
          />
        </View>
        <View style={field}>
          <FormTextInput
            title={this.t('payments.order', 'Order')}
            placeholder={this.t('payments.enter_order', 'Enter order')}
            type="number"
            current_data={this.state.rank}
            update_data={txt => this.setState({rank: onHandleNumberFieldChange(txt)})}
          />
        </View>

        <View style={[commonStyle.switchViewStyle, {marginTop: 4, marginBottom: 14}]}>
          <Text style={commonStyle.titleNameStyle}>{this.t('payments.active', 'Active')}</Text>
          <View style={{width: itsMobileView ? '12%' : '20%'}}>
            <Switch
              onColor={colors.AppNewGreen}
              onChange={() => this.setState({status: !this.state.status})}
              checked={this.state.status}
              height={22}
              width={50}
            />
          </View>
        </View>

        <View style={[commonStyle.switchViewStyle, {marginBottom: 14}]}>
          <Text style={commonStyle.titleNameStyle}>{this.t('payments.default', 'Default')}</Text>
          <View style={{width: itsMobileView ? '12%' : '20%'}}>
            <Switch
              onColor={colors.AppNewGreen}
              onChange={() => this.setState({default: !this.state.default})}
              checked={this.state.default}
              height={22}
              width={50}
            />
          </View>
        </View>
        <View style={{height: 20}} />
      </View>
    );
  };

  renderStep3 = () => {
    const integration = this.getIntegrationComponent();
    if (!integration) return null;
    return (
      <View style={{flex: 1}}>
        {integration}
      </View>
    );
  };

  render() {
    const {step} = this.state;
    return (
      <SafeAreaView
        style={[styles.Container,
          {backgroundColor: this.context?.colors?.screenBackground ?? AppColor.AppLightGreen}]}
        className="payments-page">
        <ScrollView style={{flex: 1}} stickyHeaderIndices={[0]}>
          {this.renderStepper()}
          {step === 1 && this.renderStep1()}
          {step === 2 && this.renderStep2()}
          {step === 3 && this.renderStep3()}
        </ScrollView>
        <Appload enable={this.state.dataLoad} />
      </SafeAreaView>
    );
  }
}
export default withLocale(AddPaymentMenthod);

const styles = StyleSheet.create({
  Container: {
    flex: 1,
    backgroundColor: 'var(--color-bg)',
  },
});
